import MessageLoaderLarge from "./MessageLoaderLarge";
import MessageLoaderSmall from "./MessageLoaderSmall";
import MessageLoaderVersion from "./MessageLoaderVersion";

type LoaderVariant = "small" | "large" | "version";

type Props = {
    variant: LoaderVariant;
};

const MessageLoader = ({ variant }: Props) => {
    switch (variant) {
        case "large":
            return <MessageLoaderLarge />;
        case "version":
            return <MessageLoaderVersion />;
        case "small":
        default:
            return <MessageLoaderSmall />;
    }
};

export default MessageLoader;
